<template>
    <div class="loto-games">
        {{}}
        <template v-for="(v, k, i) in dataSource" :key="i">
            <div class="loto__game-list">
                <template v-for="(item, index) in v" :key="index">
                    <div class="loto__game-item" @click="onGoToEvent(item)">
                        <img class="loto__game-item__img" :src="require(`@/public/img/${$store.state.config.skin}/lotto/${item.img}-en.png`)" />
                        <div class="loto__game-item__title">
                            <img class="loto__game-item__title__img" :src="require(`@/public/img/${$store.state.config.skin}/lotto/note.svg`)" />
                            <span class="loto__game-item__title__text">{{ getTranslatedText(k) }}</span>
                        </div>

                        <div class="loto__game-item__play">
                            <span class="loto__game-item__play__text"> {{ getTranslatedText('play') }}</span>
                            <img class="loto__game-item__play__img" :src="require(`@/public/img/${$store.state.config.skin}/arrows.svg`)" />
                        </div>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';

export default {
    mixins: [languageMixins],
    components: {},
    props: {
        dataSource: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    methods: {
        onGoToEvent(item) {
            this.$store.commit('SET_GAME_SELECTED', item);
            const query = this.$route.query;
            this.$router.push({ path: '/loto-event', query });
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/games.scss';
</style>
